import { render, staticRenderFns } from "./product-category.vue?vue&type=template&id=4febc055&scoped=true&"
import script from "./product-category.vue?vue&type=script&lang=js&"
export * from "./product-category.vue?vue&type=script&lang=js&"
import style0 from "./product-category.vue?vue&type=style&index=0&id=4febc055&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4febc055",
  null
  
)

export default component.exports